import { dispatchAction, } from 'application/AppDispatcher';
const { view: dispatchViewAction, } = dispatchAction;
import { namespacedConsts, } from 'utils/object';
const BROWSI_ACTIONS = namespacedConsts({
  ACTIONS: {
    SCRIPT_LOAD: {
      BEFORE: true,
      AFTER: true,
    },
  },
});
const { ACTIONS, } = BROWSI_ACTIONS;
const { BEFORE, AFTER, } = ACTIONS.SCRIPT_LOAD;
const browsiActions = {
  TYPES: ACTIONS,
  scriptLoadingStart: dispatchViewAction.part({ type: BEFORE, }),
  scriptLoadingEnd: dispatchViewAction.part({ type: AFTER, }),
};
export default browsiActions;


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/browsiActions.js